import React, { useState } from 'react';

const GSTBilling = () => {
  const [billType, setBillType] = useState('Regular Bills');
  const [param, setParam] = useState('April-2025');

  const params = ['April-2025', 'May-2025', 'June-2025', 'July-2025', 'August-2025', 'September-2025', 'October-2025', 'November-2025', 'December-2025', 'January-2026', 'February-2026', 'March-2026'];
  const suppParams = ['sup-bill'];

  return (
    <div className="fade-in">
      <div className="page-header">
        <div className="breadcrumb">Gst Reports <span>/ Members Billing</span></div>
        <h2>GSTR - Billing</h2>
      </div>

      <div className="filter-bar">
        <div className="form-group">
          <label>Select Type</label>
          <select className="form-control" value={billType} onChange={e => setBillType(e.target.value)}>
            <option>Regular Bills</option>
            <option>Supplementary Bills</option>
          </select>
        </div>
        <div className="form-group">
          <label>Select {billType === 'Regular Bills' ? 'Regular' : 'Supplementary'} Bill Parameter</label>
          <select className="form-control" value={param} onChange={e => setParam(e.target.value)}>
            {(billType === 'Regular Bills' ? params : suppParams).map(p => (
              <option key={p}>{p}</option>
            ))}
          </select>
        </div>
        <div className="form-group" style={{ justifyContent: 'flex-end', marginLeft: 'auto' }}>
          <button className="btn btn-success btn-sm">📊 Export To Excel</button>
        </div>
      </div>

      <div className="card">
        <div className="report-header">
          <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
          <p>TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
          <p style={{ fontWeight: '700', marginTop: '6px' }}>
            GSTR Billing — {billType} — Parameter: {param}
          </p>
        </div>
        <div className="empty-state">
          <div style={{ fontSize: '48px' }}>📋</div>
          <p>Select bill type and parameter then click Export to generate GSTR billing report</p>
        </div>
      </div>
    </div>
  );
};

export default GSTBilling;
